/*************************
  🚨 Auto-generated file. Do not modify directly!
  🚨 Instead, modify ./svg-template.ts or the SVG file
  🚨 See packages/bundler for more info
*************************/
import * as React from 'react';
import type { SVGIconProps } from '../types';
export function ID({
  className,
  size,
  style
}: SVGIconProps) {
  const props = {
    preserveAspectRatio: 'xMidYMid meet',
    className,
    style: {
      verticalAlign: 'middle',
      ...style
    },
    width: size ?? '1em',
    height: size ?? '1em'
  };
  return <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16" {...props}><g clipPath="url(#ID_svg__a)"><path fill="currentColor" fillRule="evenodd" d="M.9 3.5A2.6 2.6 0 0 1 3.5.9h9a2.6 2.6 0 0 1 2.6 2.6v9a2.6 2.6 0 0 1-2.6 2.6h-9a2.6 2.6 0 0 1-2.6-2.6v-9Zm2.6-1.4a1.4 1.4 0 0 0-1.4 1.4v9a1.4 1.4 0 0 0 1.4 1.4h9a1.4 1.4 0 0 0 1.4-1.4v-9a1.4 1.4 0 0 0-1.4-1.4h-9Zm1.876 2.588a.688.688 0 1 0-1.376 0v6.624a.688.688 0 1 0 1.376 0V4.688ZM7.508 12h1.308c.66 0 1.228-.16 1.703-.48.477-.32.842-.78 1.097-1.38.256-.598.384-1.314.384-2.148 0-.83-.128-1.544-.384-2.14-.255-.597-.618-1.054-1.09-1.372C10.052 4.16 9.488 4 8.834 4H7.508a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1Zm1.25-1.45h-.874v-5.1h.878c.406 0 .749.088 1.026.265.278.177.486.453.626.828.142.375.213.858.213 1.45 0 .596-.07 1.083-.213 1.46-.14.375-.35.652-.63.832-.277.177-.619.266-1.026.266Z" clipRule="evenodd" /></g><defs><clipPath id="ID_svg__a"><path fill="#fff" d="M0 0h16v16H0z" /></clipPath></defs></svg>;
}
;